import { API_BASE_URL, API_CDN_URL } from "configs/AppConfig";

export const api_base_url = API_BASE_URL + "/api";
export const api_cdn_url = API_CDN_URL + "/api";

export const sekret = "/sekret";
export const tum = "/tum";
export const master = "/master-data";
export const setting = "/pengaturan";

export const API_URL = {
  // AUTH
  login: api_base_url + "/login",

  // TUM
  dashboard: api_base_url + tum + "/dashboard",
  pegawai: api_base_url + tum + "/pegawais",
  bko: api_base_url + tum + "/bko",
  hukdis: api_base_url + tum + "/hukdis",
  searchPegawai: api_base_url + tum + "/search-pegawai",
  kgb: api_base_url + tum + "/kgb",
  kppn: api_base_url + tum + "/kgb-kppn",
  kgbGaji: api_base_url + tum + "/kgb-gaji",
  tunpas: api_base_url + tum + "/tunpas",
  slks: api_base_url + tum + "/slks",
  penghargaan: api_base_url + tum + "/penghargaan",
  plh: api_base_url + tum + "/plh",
  diklatUkom: api_base_url + tum + "/pegawai-ukom",

  // Master Data
  satker: api_base_url + master + "/satkers",
  bidang: api_base_url + master + "/bidangs",
  subbid: api_base_url + master + "/subbids",
  subsi: api_base_url + master + "/subsis",
  pangkat: api_base_url + master + "/pangkats",
  jabatan: api_base_url + master + "/jabatans",

  // Setting
  user: api_base_url + setting + "/users",
  role: api_base_url + setting + "/roles",
  permission: api_base_url + setting + "/permissions",
  profile: api_base_url + setting + "/profile",

  folder: api_base_url + tum + "/dokumen",
  file: api_base_url + tum + "/dokumen/file",

  select: api_base_url + "/select",
  upload: api_cdn_url + "/upload",
};
